import {useMutation} from 'react-query';
import {postPrepaymentSuggest} from 'services/postDetail/prepaymentSuggest';

const useSetPrepaymentSuggest = (
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IPrepaymentSuggestProps) => {
      return postPrepaymentSuggest(payload);
    },
    onSuccess: (_, variables) => {
      setIsOpen(false);
    },
  });

  return {isLoading, mutate};
};

export default useSetPrepaymentSuggest;
